import { GetContracts } from "../../../../actionTypes/contract";

export function getContractsAction() {
  return {
    type: GetContracts.REQUEST,
  };
}
